/* eslint-disable */

const pageEvents = document.querySelector('body.template-evenements');

if (pageEvents) {


  const elements = document.querySelectorAll(".event");
  const loadMoreBtn = document.querySelector("#loadMore");

  const start = 0;
  const step = 2;

  const content_arr = Array.from(elements);

  content_arr.splice(start, step).map(e => e.classList.add("active"));

  loadMore.onclick = function(e) {
    content_arr.splice(start, step).map(e => e.classList.add("active"));

    if (content_arr.length === 0) {
      loadMoreBtn.style.display = "none";
    }
  };



}


// WEBPACK FOOTER //
// ./scripts/events.js